import { type DialogProps } from "@mui/material";
import { type FC } from "react";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppInput } from "../../../../shared/components/AppInput";
import { FolderNameChangeModal } from "../../../Modals/FolderNameChangeModal";
import { useStylist } from "../../hook/use-stylist";
import { selectSelectedStylist } from "../../redux/selectors";
import styles from "./styles.module.css";

interface Props extends DialogProps {
  closeModal: () => void;
  childId?: string;
}

export const StylistFolderNameChange: FC<Props> = ({
  childId,
  closeModal,
  ...props
}) => {
  const { handleFieldChange } = useStylist();
  const selectedStylist = useAppSelector(selectSelectedStylist);

  return (
    <FolderNameChangeModal
      closeModal={closeModal}
      onClose={closeModal}
      onOk={() => {
        closeModal();
      }}
      {...props}
    >
      <div className={styles.container}>
        <AppInput
          value={selectedStylist?.friendly_name as string}
          className={styles.input}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFieldChange(event, "friendly_name", "name");
          }}
        />
      </div>
    </FolderNameChangeModal>
  );
};
